/*
  Login-offer campaign popups.
  - Guests: "New to Comet?" popup (snippets/offer-login-popup.liquid). It has no × and can't be
    closed by overlay click or Escape; it shows on every page until one of its CTAs is picked,
    then stays away for the session.
      Existing Customer → popup closes, visitor stays on the current page (no login needed).
      New Customer      → opens the OTP box (closable as normal, login stays optional).
  - Existing customers: forced redirect popup (snippets/existing-customer-redirect.liquid) for
    anyone who picked "New Customer" but turns out to be existing, until Explore Now is clicked.
  New customers get no popup after login.
*/
(() => {
  const CTA_CHOSEN_KEY = 'offer_cta_chosen';
  const NEW_CHOSEN_KEY = 'offer_new_chosen';
  const REDIRECT_SEEN_KEY = 'offer_redirect_seen';
  const OPEN_CLASS = 'customer-offer-popup-open';

  const storage = {
    get: (key) => {
      try {
        return sessionStorage.getItem(key);
      } catch (error) {
        return null;
      }
    },
    set: (key) => {
      try {
        sessionStorage.setItem(key, 'true');
      } catch (error) {
        /* Blocked storage: popup may show again, which is acceptable. */
      }
    },
  };

  const openPopup = (popup) => {
    popup.hidden = false;
    document.documentElement.classList.add(OPEN_CLASS);
  };

  const closePopup = (popup) => {
    popup.hidden = true;
    document.documentElement.classList.remove(OPEN_CLASS);
  };

  /* Non-IN markets show the shipping-location popup first; never stack on top of it. */
  const whenShippingPopupClosed = (callback) => {
    const shippingPopup = document.getElementById('shipping-location-popup');
    const isVisible = () => shippingPopup && getComputedStyle(shippingPopup).display !== 'none';
    if (!isVisible()) {
      callback();
      return;
    }
    const observer = new MutationObserver(() => {
      if (isVisible()) return;
      observer.disconnect();
      callback();
    });
    observer.observe(shippingPopup, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
  };

  /* No close handlers on purpose: only the two CTAs dismiss it. The snippet isn't rendered for
     logged-in customers. */
  const initLoginPopup = () => {
    const popup = document.querySelector('[data-customer-offer-popup="login"]');
    if (!popup || storage.get(CTA_CHOSEN_KEY)) return;

    popup.querySelector('[data-customer-offer-existing]')?.addEventListener('click', () => {
      storage.set(CTA_CHOSEN_KEY);
      closePopup(popup);
    });

    popup.querySelector('[data-customer-offer-new]')?.addEventListener('click', () => {
      /* Lets the existing-customer popup catch existing customers who picked "New Customer". */
      storage.set(NEW_CHOSEN_KEY);
      storage.set(CTA_CHOSEN_KEY);
      closePopup(popup);
      const loginButton = document.getElementById('login-button') ?? document.querySelector('.otp-login-button');
      loginButton?.click();
    });

    whenShippingPopupClosed(() => openPopup(popup));
  };

  const initExistingPopup = () => {
    const popup = document.querySelector('[data-customer-offer-popup="existing"]');
    if (!popup || !storage.get(NEW_CHOSEN_KEY) || storage.get(REDIRECT_SEEN_KEY)) return;

    /* Forced, as on 500k-insta: no close handlers, and it comes back on every page until
       Explore Now is clicked, so a refresh can't skip it. */
    const exploreButton = popup.querySelector('.customer-offer-popup-btn');
    exploreButton?.addEventListener('click', () => storage.set(REDIRECT_SEEN_KEY));
    openPopup(popup);
  };

  /* DOMContentLoaded fires after every deferred script, so shipping-location-popup.js has
     already decided whether to show by the time we check. */
  const init = () => {
    initLoginPopup();
    initExistingPopup();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
